















































































































































































































































import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";

import {
  ticketClient,
  authorClient,
  client,
  collectionServiceClient,
  dialerClient,
} from "@/api/index";
import {
  GetAudioQualityScriptListReq,
  Bool,
  OpenTicketReq,
  AudioQualityScriptData,
  SaveAudioQualityScriptReq,
} from "@/pbjs/external/ticket/ticket_pb";
import {
  ListUserGroupByTypeReq,
  ListUserGroupByMutiTypeReq,
} from "@/pbjs/external/auth/auth_pb";
import { ExecType } from "@/pbjs/xcommon/enum_pb";
import { timeFormat, downloadFile, setValue } from "@/utils/index";
import {
  SearchUserReq,
  BatchGetLoginInfoReq,
  GetOutSourceInfoReq,
} from "@/pbjs/external/user/user_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, handleResponse, setPage, errorMsg } from "@/utils/request";
import { DialInfoReq } from "@/pbjs/xcommon/dialer_pb";

@Component({
  name: "addnewTalkPoint",
  components: {
    MaskComponent: () => import("../Mask.vue"),
  },
})
export default class addnewTalkPoint extends Vue {
  @Prop() robotCallDetail: any;
  @Provide() private userForm: any = {
    TalkPointName: null,
    keywordsPhrases: null,
  };
  @Provide() private dialogdetailList: any = [];

  @Provide() private inputVisible: boolean = false;
  @Provide() private showDialogTypeId: number = 0;
  @Provide() private duration: any = "";
  @Provide() private disnumber: any = "";
  @Provide() private suppliername: any = "";
  @Provide() private overduedays: any = "";
  @Provide() private isdial: any = "";
  @Provide() private hangupcause: any = "";
  @Provide() private suggest: any = "";
  @Provide() private calltime: any = "";
  @Provide() private calltags: any = "";
  @Provide() private unconnectreason: any = "";
  @Provide() private audiorecordurl: any = "";
  @Provide() private audioPlayLoading: Boolean = false;

  //   private created(){
  //       this.addNewPoint(this.flag,this.dataRes)
  //   }
  @Watch("robotCallDetail", { deep: true, immediate: true }) //深度监听多次
  onchanged(val: any | null) {

    if (val) {

      //       audioid: "0"
      // calltags: ""
      // calltime: 0
      // ctime: 0
      // dialogdetailList: []
      // hangupcause: ""
      // id: 0
      // isdial: 0
      // orderid: "0"
      // overduedays: 0
      // suggest: ""
      // suppliername: ""
      // unconnectreason: ""
      this.suppliername = val.suppliername; //供应商
      this.overduedays = val.overduedays; //逾期天数
      this.isdial =
        +val.isdial == 1 ? this.$t("v0707.Yes") : this.$t("v0707.No"); //是否拨通
      this.hangupcause = val.hangupcause; //挂机方向
      this.suggest = val.suggest; //处理建议、
      this.calltime = timeFormat(val.calltime); //拨打时间,
      this.calltags = val.calltags; // 通话标签
      this.unconnectreason = val.unconnectreason; // 未接通原因
      this.dialogdetailList = val.robotdialogList;
      this.getDialInfo(val.audioid);
      this.getAudio(val.audioid);
    }
  }

  private hideMaskVue() {
    this.$emit("hideManualUpgradeTicketDialogue", {
      hidden: true,
      val: null,
    });
  }
  private closeDialog() {
    this.$emit("hideManualUpgradeTicketDialogue", {
      hidden: true,
      val: 0,
    });
  }
  // lee 获取录音文件
  private async getAudio(callrecordid: any) {
    // row.videoLoading = true;
    this.audioPlayLoading = true;
    const { getDialListMediaV2 }: any = await import("@/request/getDialList");
    let _arg = {
      VOIPRecordID: callrecordid,
    };
    let response = await getDialListMediaV2(_arg);
    if (response && response.right) {
      // row.videoLoading = false;
      // row.videoShow = true;
      this.audioPlayLoading = false;
      this.audiorecordurl =
        "data:" + response.mediaheader + ";base64," + response.mediabody;
      //   this.timelong=timelong
      //   this.audio=this.$refs.audioExl
      //   this.audio.currentTime=val
      //   this.audio.play()
      //   this.sliderValue[index]=100
    }
  }
  // lgy 号码脱敏，保留后四位，前面按位数打星号
  private numberEncryption(number: string) {
    let len: number = number.length - 4;
    let numStrPre: string = number.substring(len, len + 4);
    let newNum: string = "";
    for (let i = 0; i < len; i++) {
      newNum += "*";
    }
    return newNum + numStrPre;
  }
  //获取补充详情接口
  private async getDialInfo(callrecordid: any) {
    let request = new DialInfoReq();
    request.setCommonin(setCommon());
    request.setDialid(callrecordid);
    dialerClient.dialInfo(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        this.disnumber = data.destnumber
          ? this.numberEncryption(data.destnumber)
          : "";
        this.duration = data.billsec;
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
}
